import { Skeleton } from '../../../platform/async/Skeleton'
import type { AsyncState } from '../../../platform/async/Async'
import { DayHeatmap } from '../../../platform/charts/DayHeatmap'
import { OverviewWidget } from '../OverviewWidget'
import type { HeatmapView } from './heatmapView'

const WEEKDAY_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const

/**
 * When you spend: this month's spend by day as a calendar heatmap (the owner's
 * monthly view; the design's "last 5 weeks" is replaced). The chip names the
 * heaviest weekday and is absent on a tie. Live surface: never stale.
 */
export function HeatmapWidget({ state, month, today }: { state: AsyncState<HeatmapView>; month: string; today: string }) {
  return (
    <OverviewWidget<HeatmapView>
      title="When you spend"
      subtitle={`${month} by day`}
      surface="transactions"
      fill
      state={state}
      headExtra={
        state.status === 'success' && state.data.worst !== null ? (
          <span className="ov-chip ov-chip--insight">{`${WEEKDAY_SHORT[state.data.worst]} is worst`}</span>
        ) : null
      }
      skeleton={
        <div className="ov-heat__skeleton" aria-hidden="true">
          {Array.from({ length: 35 }, (_, i) => (
            <Skeleton key={i} height={16} />
          ))}
        </div>
      }
      empty={{ title: `No spending in ${month} yet` }}
    >
      {(data, headingId) => (
        <>
          <DayHeatmap days={data.days} currency={data.currency} today={today} worst={data.worst} labelledBy={headingId} />
          {data.otherCurrencyCount > 0 && (
            <p className="note">{`${data.otherCurrencyCount} transaction${data.otherCurrencyCount === 1 ? '' : 's'} in other currencies aren't shown`}</p>
          )}
        </>
      )}
    </OverviewWidget>
  )
}
